import { SET_SETTINGS_FORM_MODAL_OPEN_STATUS } from '../actionTypes';
import { actions } from '../reducer';

export default (value) => actions[SET_SETTINGS_FORM_MODAL_OPEN_STATUS](value);
